
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class RejectionDialog extends Vue {
  @Prop({ type: Boolean, required: true }) readonly value!: boolean;
  @Prop({ type: Number, required: true }) readonly itemCount!: number;
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop({ type: Number, default: 1 }) readonly poCount!: number;
  @Prop({ type: Object, default: null }) readonly singlePo!: any;

  reason = '';
  valid = false;
  
  reasonRules = [
    (v: string) => !!v || 'Reason is required',
    (v: string) => (v && v.trim().length > 0) || 'Reason cannot be empty',
    (v: string) => (v && v.length >= 10) || 'Reason must be at least 10 characters',
  ];

  get dialog(): boolean {
    return this.value;
  }

  set dialog(value: boolean) {
    this.$emit('input', value);
  }

  @Watch('value')
  onDialogChange(newVal: boolean) {
    if (!newVal) {
      // Reset form when dialog closes
      this.reason = '';
      (this.$refs.form as any)?.reset();
    }
  }

  cancel() {
    this.dialog = false;
    this.$emit('cancel');
  }

  confirm() {
    if ((this.$refs.form as any)?.validate()) {
      this.$emit('confirm', { reason: this.reason.trim() });
    }
  }
}
